// extracted by mini-css-extract-plugin
export var body = "BetCard-module--body--3d27e";
export var card = "BetCard-module--card--dc2c5";
export var root = "BetCard-module--root--5f44b";